import request from '../utils/request'
export const listFeedbacks = params => request.get('/feedbacks', { params })
export const getFeedback = id => request.get(`/feedbacks/${id}`)
export const saveFeedback = (id, data) => id ? request.patch(`/feedbacks/${id}`, data) : request.post('/feedbacks', data)
export const publishFeedback = id => request.post(`/feedbacks/${id}/publish`)
export const listNotices = params => request.get('/notices', { params })
export const saveNotice = (id, data) => id ? request.patch(`/notices/${id}`, data) : request.post('/notices', data)
export const publishNotice = id => request.post(`/notices/${id}/publish`)
export const revokeNotice = id => request.post(`/notices/${id}/revoke`)
export const listPayments = params => request.get('/payments', { params })
export const savePayment = (id, data) => id ? request.patch(`/payments/${id}`, data) : request.post('/payments', data)
export const confirmPayment = (id, data) => request.post(`/payments/${id}/confirm`, data)
export const cancelPayment = id => request.post(`/payments/${id}/cancel`)
export const refundPayment = (id, data) => request.post(`/payments/${id}/refund`, data)
export const listUsers = params => request.get('/users', { params })
export const saveUser = (id, data) => id ? request.patch(`/users/${id}`, data) : request.post('/users', data)
export const deleteUser = id => request.delete(`/users/${id}`)
export const updateUserStatus = (id, status) => request.patch(`/users/${id}/status`, { status })
export const resetUserPassword = (id, newPassword) => request.post(`/users/${id}/reset-password`, { newPassword })
export const setStudentParentPassword = (studentId, newPassword) => request.post(`/students/${studentId}/parent-password`, { newPassword })
